import * as requestFromServer from "./productsCrud";
import { productsSlice, callTypes } from "./productsSlice";
import Axios from 'axios'
import { fetchSecondaryImages } from "../brands/brandsActions";
import { brandsSlice, brandCallTypes } from "../brands/brandsSlice";

const { actions } = productsSlice;
const { brandActions } = brandsSlice;

export function getCookie(name) {
  var cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export const fetchProducts = (queryParams, page, pageSize, brands, category, keyword) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'get',
    params: {
      page: page,
      page_size: 8,
      brand__in: `${brands ? brands : ""}`,
      category__in: `${category ? category : ""}`,
      search: `${keyword ? keyword : ""}`
    },
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/body/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      let entities = response.data.results.sort((a, b) => b.id - a.id)
      let totalCount = response.data.count
      console.log(entities)
      dispatch(actions.productsFetched({ totalCount, entities }));
      // if (queryParams) {
      //   dispatch(fetchSecondaryImages(entities))
      // }
      return entities
    })
    .catch(error => {
      console.log(error)
    });
};

export const fetchAllBrands = (queryParams, page, pageSize) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'get',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/brand/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      let entities = response.data
      let totalCount = response.data.length
      console.log(entities)
      dispatch(brandActions.brandsFetched({ totalCount, entities }));
      // if (queryParams) {
      //   dispatch(fetchSecondaryImages(entities))
      // }
      return entities
    })
    .catch(error => {
      console.log(error)
    });
};

export const fetchProduct = id => dispatch => {
  if (!id) {
    return dispatch(actions.productFetched({ productForEdit: undefined }));
  }
  let code = getCookie("authToken")
  return Axios({
    method: 'get',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/body/${id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(actions.productFetched({ product: response.data }));
      return response
    })
    .catch(error => {
      console.log(error)
    });
};

export const deleteProduct = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  let code = getCookie("authToken")
  return Axios({
    method: 'delete',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/body/${id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      console.log(response)
      dispatch(fetchProducts(false, 1))
      dispatch(actions.productDeleted(id))
      return response
    })
    .catch(error => {
      console.log(error)
    });
};

export const createProduct = (productForCreation, next) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  let data = new FormData()

  for (var key in productForCreation) {
    data.append(key, productForCreation[key])
  }
  let code = getCookie("authToken")
  Axios({
    method: 'post',
    url: process.env.REACT_APP_BACKEND_URL + '/api/admin/body/',
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
    data,
  })
    .then(response => {
      if (response.status === 400) {
        let errors = Object.values(response.data)
        let errorKeys = Object.keys(response.data)
        let errorString = ""
        for (let i = 0; i < errors.length; i++) {
          errorString += `${errorKeys[i]}: ${errors[i]} \n`
        }
        alert(errorString)
      } else {
        dispatch(actions.currentProduct({ currentProduct: response.data, next: true }))
      }
    })
    .catch(error => {
      console.log(error)
    });
};

export const skip = (productForCreation, next) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  dispatch(actions.currentProduct({ currentProduct: {}, next: false }))
  return {};
};

export const updateProduct = (product, image, backToProductsList) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  let data = new FormData()

  let code = getCookie("authToken")
  for (var key in product) {
    if (key !== "image") {
      data.append(key, product[key])
    }
  }
  Axios({
    method: 'put',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/body/${product.id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
    data,
  })
    .then(response => {
      if (response.status === 400) {
        let errors = Object.values(response.data)
        let errorKeys = Object.keys(response.data)
        let errorString = ""
        for (let i = 0; i < errors.length; i++) {
          errorString += `${errorKeys[i]}: ${errors[i]} \n`
        }
        alert(errorString)
      } else {
        dispatch(actions.currentProduct({ currentProduct: response.data, next: true }))
      }
    })
    .catch(error => {
      console.log(error)
    });
  if (image) {
    let newData = new FormData()
    newData.append('image', image)
    newData.append('category', product.category)
    newData.append('name', product.name)
    newData.append('slug', product.slug)
    Axios({
      method: 'put',
      url: process.env.REACT_APP_BACKEND_URL + `/api/admin/body/${product.id}/`,
      validateStatus: (status) => {
        return true;
      },
      headers: { Authorization: `Bearer ${code}` },
      data: newData,
    })
      .then(response => {
        if (response.status === 400) {
          let errors = Object.values(response.data)
          let errorKeys = Object.keys(response.data)
          let errorString = ""
          for (let i = 0; i < errors.length; i++) {
            errorString += `${errorKeys[i]}: ${errors[i]} \n`
          }
          alert(errorString)
        } else {
          console.log(response)
          dispatch(actions.currentProduct({ currentProduct: response.data, next: true }))
        }
      })
      .catch(error => {
        console.log(error)
      });
  }
};

export const updateProductsStatus = (ids, status) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatusForProducts(ids, status)
    .then(() => {
      dispatch(actions.productsStatusUpdated({ ids, status }));
    })
    .catch(error => {
      error.clientMessage = "Can't update products status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteProducts = (ids, onHide) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  let code = getCookie("authToken")
  ids.map((a, i) => {
    return Axios({
      method: 'delete',
      url: process.env.REACT_APP_BACKEND_URL + `/api/admin/body/${a}/`,
      validateStatus: (status) => {
        return true;
      },
      headers: { Authorization: `Bearer ${code}` },
    })
      .then(response => {
        if (i === (ids.length - 1)) {
          onHide()
        }
        return response
      })
      .catch(error => {
        console.log(error)
      });
  })
};

export const getVenders = () => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  let code = getCookie("authToken")
  Axios({
    method: 'get',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/vendor/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(actions.vendors({ vendors: response.data }))
    })
    .catch(error => {
      console.log(error)
    });
};

export const addLinks = (arr, id) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  arr.map((a) => {
    let data = new FormData()
    for (var key in a) {
      data.append(key, a[key])
    }
    data.append('product', id)
    let code = getCookie("authToken")
    Axios({
      method: 'post',
      url: process.env.REACT_APP_BACKEND_URL + `/api/admin/body-link/`,
      validateStatus: (status) => {
        return true;
      },
      headers: { Authorization: `Bearer ${code}` },
      data,
    })
      .then(response => {
        dispatch(actions.currentProduct({ currentProduct: {}, next: false }))
      })
      .catch(error => {
        console.log(error)
      });
  })
};

export const addSecondaryImages = (arr, id) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  arr.map((a) => {
    let data = new FormData()
    console.log(a)
    data.append("image", a.originFileObj)
    data.append('product', id)
    let code = getCookie("authToken")
    Axios({
      method: 'post',
      url: process.env.REACT_APP_BACKEND_URL + `/api/admin/secondary-image/`,
      validateStatus: (status) => {
        return true;
      },
      headers: { Authorization: `Bearer ${code}` },
      data,
    })
      .then(response => {
        dispatch(actions.currentProduct({ currentProduct: {}, next: false }))
      })
      .catch(error => {
        console.log(error)
      });
  })
};

export const deleteSecondaryImages = (arr, id) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  arr.map((a) => {
    let code = getCookie("authToken")
    Axios({
      method: 'delete',
      url: process.env.REACT_APP_BACKEND_URL + `/api/admin/secondary-image/${a}/`,
      validateStatus: (status) => {
        return true;
      },
      headers: { Authorization: `Bearer ${code}` },
    })
      .then(response => {
        console.log(response.data)
        // dispatch(actions.currentProduct({ currentProduct: {}, next: false }))
      })
      .catch(error => {
        console.log(error)
      });
  })
};

export const deleteLinks = (arr, id) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  arr.map((a) => {
    let code = getCookie("authToken")
    Axios({
      method: 'delete',
      url: process.env.REACT_APP_BACKEND_URL + `/api/admin/body-link/${a}/`,
      validateStatus: (status) => {
        return true;
      },
      headers: { Authorization: `Bearer ${code}` },
    })
      .then(response => {
        console.log(response.data)
        // dispatch(actions.currentProduct({ currentProduct: {}, next: false }))
      })
      .catch(error => {
        console.log(error)
      });
  })
};

export const updateLinks = (arr, id) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  let code = getCookie("authToken")
  arr.map((a) => {
    let data = new FormData()

    for (var key in a) {
      data.append(key, a[key])
    }
    return Axios({
      method: 'put',
      url: process.env.REACT_APP_BACKEND_URL + `/api/admin/body-link/${a.id}/`,
      validateStatus: (status) => {
        return true;
      },
      headers: { Authorization: `Bearer ${code}` },
      data,
    })
      .then(response => {
        // dispatch(fetchLinks(false, 1))
        return response
      })
      .catch(error => {
        console.log(error)
      });
  })
};

export const fetchLinks = (queryParams, page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'get',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/body-link/?page=${page}&page_size=${8}`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      let entities = response.data.results
      let totalCount = response.data.count
      console.log(entities)
      dispatch(actions.fetchedSkinLinks({ totalCount, entities }));
      return entities
    })
    .catch(error => {
      console.log(error)
    });
};

export const fetchSkinLink = slug => dispatch => {
  if (!slug) {
    return dispatch(actions.productFetched({ productForEdit: undefined }));
  }
  console.log(slug)
  dispatch(actions.startCall({ callType: callTypes.list }));
  dispatch(actions.skinLinkFetched({ slug: slug }));
};

export const createSkinCareLink = (productForCreation, back) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  let data = new FormData()

  for (var key in productForCreation) {
    data.append(key, productForCreation[key])
  }
  let code = getCookie("authToken")
  Axios({
    method: 'post',
    url: process.env.REACT_APP_BACKEND_URL + '/api/admin/skin-link/',
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
    data,
  })
    .then(response => {
      back()
    })
    .catch(error => {
      console.log(error)
    });
};


export const deleteSkinLink = (id, page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  let code = getCookie("authToken")
  return Axios({
    method: 'delete',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/body-link/${id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(actions.skinLinksDeleted(id))
      fetchLinks(false, 1)
      return response
    })
    .catch(error => {
      console.log(error)
    });
};

export const updateSkinCareLink = (productForEdit, page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  let data = new FormData()

  for (var key in productForEdit) {
    data.append(key, productForEdit[key])
  }
  let code = getCookie("authToken")
  return Axios({
    method: 'put',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/body-link/${productForEdit.id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
    data,
  })
    .then(response => {
      fetchLinks(false, 1)
      return response
    })
    .catch(error => {
      console.log(error)
    });
};